export default {"src":"/_next/static/media/CAG.11d52190.svg","height":18,"width":18};